import React, { JSX } from 'react';
import { Box } from '@chakra-ui/react';

import { METRIC_BY_KEY, MetricKey, ThresholdMap } from '../utils/metrics';
import ChartTooltipEntry from './ChartTooltipEntry';
import ChartTooltipHeader from './ChartTooltipHeader';

interface ChartDataPoint {
  weekLabel: string;
  weekStart: string;
  weekEnd: string;
  weekNumber: number;
}

interface TooltipPayloadEntry {
  dataKey: MetricKey;
  value: number;
  color: string;
  payload: ChartDataPoint;
}

export interface ChartTooltipProps {
  active?: boolean;
  payload?: TooltipPayloadEntry[];
  thresholdMap: ThresholdMap;
  translations: (key: string, params?: Record<string, string>) => string;
}

const ChartTooltip = ({ active, payload, thresholdMap, translations }: ChartTooltipProps): JSX.Element | null => {
  if (!active || !payload?.length) return null;

  const { weekNumber, weekStart, weekEnd } = payload[0].payload;

  return (
    <Box bg="white" border="1px solid" borderColor="grey.30" borderRadius="md" px={3} py={2} boxShadow="md">
      <ChartTooltipHeader weekNumber={weekNumber} weekStart={weekStart} weekEnd={weekEnd} />
      {payload.map((entry) => {
        const metric = METRIC_BY_KEY[entry.dataKey];
        if (!metric) return null;
        return (
          <ChartTooltipEntry
            key={entry.dataKey}
            label={translations(metric.translationKey)}
            color={entry.color}
            value={entry.value}
            threshold={thresholdMap[entry.dataKey]}
          />
        );
      })}
    </Box>
  );
};

export default ChartTooltip;
